import * as yup from 'yup'

const academyBranchCitySchema = yup
  .string()
  .nullable()
  .when('role', {
    is: 'teacher_admin',
    then: (schema) =>
      schema
        .required('El profesor admin debe tener ciudad Barranquilla o Sincelejo.')
        .test(
          'academy-branch-city',
          'La ciudad del profesor admin debe ser Barranquilla o Sincelejo.',
          (value) => {
            if (!value) return false;
            const normalized = value.trim().toLowerCase();
            return (
              normalized === 'barranquilla' ||
              normalized.startsWith('barranquilla') ||
              normalized === 'sincelejo' ||
              normalized.startsWith('sincelejo')
            );
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  });

export const validateCreateUsers = yup.object().shape({
    first_name: yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El NOMBRE debe tener al menos 2 caracteres'),
    last_name: yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El APELLIDO debe tener al menos 2 caracteres'),
    dni: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'La cédula debe tener más de 3 caracteres numéricos'),
    phone: yup
    .string()
    .required('Campo requerido.')
    .min(4, 'El TELÉFONO debe tener más de 3 caracteres numéricos'),
    email: yup
    .string()
    .required('Campo requerido.')
    .email('Introduzca un correo electrónico válido.'),
    password: yup
    .string()
    .required('Campo requerido.')
    .min(6, 'Debe introducir una contraseña de al menos 6 caracteres.'),
    role: yup
    .string()
    .required('Campo requerido.')
    .oneOf(['user', 'admin', 'seller', 'domiciliary', 'integration', 'teacher', 'teacher_admin'], 'Debes elegir entre estas opciones'),
    status: yup
    .string()
    .required('Campo requerido.')
    .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    city: academyBranchCitySchema,
})

